import { render, staticRenderFns } from "./QuotationDetails.vue?vue&type=template&id=034c2dff&scoped=true&"
import script from "./QuotationDetails.vue?vue&type=script&lang=js&"
export * from "./QuotationDetails.vue?vue&type=script&lang=js&"
import style0 from "./QuotationDetails.vue?vue&type=style&index=0&id=034c2dff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034c2dff",
  null
  
)

export default component.exports